import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { VISIBLE_CANCEL_STATUS_DETAILS } from 'constants/order.constants';
import {
  AdditionalOrderColumn,
  CallbackUrlStatus,
  FilterDefinitionType,
  OrderCompletedBy,
  OrdersTab,
  OrderStatus,
} from 'enums';
import { useOrderQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const TraderDisputeOrdersArchive: React.FC = () => {
  const { t: tFilters } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.filters',
  });

  useOrderQueryFilters();

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      {
        label: tFilters('callback_url_status'),
        name: 'callbackUrlStatus',
        type: FilterDefinitionType.Enum,
        enum: CallbackUrlStatus,
        getDisplayName: orderUtils.getCallbackUrlStatusLabel,
      },
      {
        label: tFilters('automation_status'),
        name: 'completedBy',
        type: FilterDefinitionType.Enum,
        enum: OrderCompletedBy,
        getDisplayName: orderUtils.getCompletedByLabel,
      },
      {
        label: tFilters('cancel_reason'),
        name: 'statusDetails',
        type: FilterDefinitionType.Enum,
        enum: VISIBLE_CANCEL_STATUS_DETAILS,
        getDisplayName: orderUtils.getStatusDetailsLabel,
      },
      orderUtils.getStatusFilterDefinition([
        OrderStatus.Completed,
        OrderStatus.Cancelled,
      ]),
    ],
    [tFilters],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.TraderDisputeArchive}
      additionalColumns={[
        AdditionalOrderColumn.CancelReason,
        AdditionalOrderColumn.CancelledToDispute,
        AdditionalOrderColumn.Trader,
        AdditionalOrderColumn.StatusActive,
        AdditionalOrderColumn.AutomationStatus,
      ]}
      additionalFilters={additionalFilters}
    />
  );
};
